 

  import { Component, OnInit, ViewChild, ElementRef, OnDestroy,Injector } from '@angular/core';
import { ReportesService } from 'app/services/reportes/reportes.service';
import { RiesgoService } from '../../../services/riesgo/riesgo.service';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS  } from '@angular/material';
import * as XLSX from 'xlsx';
import { FiltrosRepComercial } from 'app/models/FiltrosRepComercial';
import { SecurityService } from 'app/services/security/security.service';
import { MessagesGeneral, MessagesStatus, MessagesTitles } from 'app/models/messages';
import { DatePipe } from '@angular/common';
import { Subscription,Observable } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import Swal from "sweetalert2";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { FormControl,FormGroup } from '@angular/forms';
import {map, startWith} from 'rxjs/operators';


export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-operaciones-detalladas-tiempo',
  templateUrl: './operaciones-detalladas-tiempo.component.html',
  styleUrls: ['./operaciones-detalladas-tiempo.component.scss'],
  providers: [MessagesTitles, MessagesGeneral, MessagesStatus,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class OperacionesDetalladasTiempoComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('TABLE', { static: true }) table: ElementRef;
  pageSizeOptions = [15, 20, 30, 50, 100, 200];
  displayedColumns = ['ANEXO', 'RUC', 'INVERSIONISTA', 'COSTO_ASESORIA', 'OPERACION', 'FECHA_OPERACION','FECHA_FIN_OPERACION'];
  headerStyle:any = [
    {cell:'A1',cells:'A1',fgColor:'1d93d0',color:'FFFFFF'},
    {cell:'B1',cells:'B1',fgColor:'1d93d0',color:'FFFFFF'},
    {cell:'C1',cells:'C1',fgColor:'1d93d0',color:'FFFFFF'},
    {cell:'D1',cells:'D1',fgColor:'1d93d0',color:'FFFFFF'},
    {cell:'E1',cells:'E1',fgColor:'1d93d0',color:'FFFFFF'},
    {cell:'F1',cells:'F1',fgColor:'1d93d0',color:'FFFFFF'},
    {cell:'G1',cells:'G1',fgColor:'1d93d0',color:'FFFFFF'}
  ];
  footerStyle:any=[
    {fgColor:'808080',color:'FFFFFF'},
    {fgColor:'808080',color:'FFFFFF'},
    {fgColor:'808080',color:'FFFFFF'},
    {fgColor:'808080',color:'FFFFFF'},
    {fgColor:'808080',color:'FFFFFF'},
    {fgColor:'808080',color:'FFFFFF'},
    {fgColor:'808080',color:'FFFFFF'}
  ]
  abrirDetalleConciliacion: boolean = false;
  loading: boolean;
  loadingUser: boolean;
  planillas: any = [];
  dataReporte: any = [];
  dataSource: any;
  fechaD: Date = new Date();
  fechaH: Date = new Date();
  arrListaAccesos: any[] = [];
  subRepContabilidad: Subscription = new Subscription();
  DTOFiltrosRepContabilidad: FiltrosRepComercial = new FiltrosRepComercial();
  arrListaRoles: any[] = [];
  usuarioLogueado: any;
  usuarioFiltro: any;
  rolUsuario: any;
  readonly ROL_ADMIN: string = 'administrador';
  readonly ROL_COMERCIAL: string = 'comercial';
  readonly ROL_JEFATURA: string = 'jefe';
  readonly ROL_GERENCIA: string = 'gerencia';
  subLista: Subscription[] = [];
  subRol: Subscription = new Subscription();
  subAcceso: Subscription = new Subscription();
  subUser: Subscription = new Subscription();
  
  riesgoService:RiesgoService;
  filteredOptions: Observable<any[]>;  
  fondoform = new FormControl();

  constructor(private reporteService: ReportesService,
    private securityService: SecurityService,
    private msgTitulos: MessagesTitles,
    private datePipe: DatePipe,
    private msgStatus: MessagesStatus,
    private injector:Injector,) { 
      
      this.riesgoService = this.injector.get<RiesgoService>(RiesgoService);
    }

  ngOnInit() {
    this.usuarioLogueado = JSON.parse(sessionStorage.getItem('UserActive'));
    this.listarFondos();
    this.ListadoRepContabilidad();
    this.securityService.headerStyle=this.headerStyle;
    this.securityService.footerStyle=this.footerStyle;
    this.securityService.displayedColumns=this.displayedColumns;

    

  }
  private _filter(value: string): any[] {
    const filterValue = value.toLowerCase();
    console.log("aaa",this.filteredOptions);
    let arrayrecor = this.arrListaAccesos;
    return arrayrecor.filter(option => option.Razon_Social.toLowerCase().includes(filterValue));
  }
  listarFondos() {
    this.riesgoService.obtenerFondos().subscribe(
      (resp: any) => {
         this.arrListaAccesos = resp
         this.arrListaAccesos.sort(function(a, b) {
          var textA = a.Razon_Social;
          var textB = b.Razon_Social;
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
        console.log("order",this.arrListaAccesos);

        this.filteredOptions = this.fondoform.valueChanges
        .pipe(
          startWith(""),
          map(state =>
            state ? this._filter(state) : this.arrListaAccesos.slice()
          )
        );

        //this.fondos = this.fondos.filter(item => item.Moneda == this.formTEM.controls['TipoCambio'].value() || item.Multiples_Moneda == 'A');
      }, (err: HttpErrorResponse) => {
        this.loading = false;
       // this.msgStatus.getMessage(err.status);
        Swal.fire({
          title: 'error',
          text: "LISTA FONDOS NO OBTENIDO. ",
          type: "error",
          allowOutsideClick: false
        });
      });
  }
  obtenerListaAccesos() {
    this.subRol = this.securityService.ObtenerListaRoles(this.usuarioLogueado.id_empresa).subscribe(
      (resRoles: any) => {
        this.arrListaRoles = resRoles;
        this.rolUsuario = this.arrListaRoles.find(r => r.id_roles == this.usuarioLogueado.id_roles);
        this.rolUsuario.Nombre = this.rolUsuario.Nombre.toLowerCase();

        this.subAcceso = this.securityService.ObtenerListaAccesos().subscribe(
          (resAccesos: any) => {
            this.arrListaAccesos = resAccesos;
            if (this.rolUsuario.Nombre.startsWith(this.ROL_JEFATURA) || this.rolUsuario.Nombre == this.ROL_GERENCIA || this.rolUsuario.Nombre == this.ROL_ADMIN) {
              this.arrListaAccesos = this.arrListaAccesos.filter(a => a.id_roles_dsc.toLowerCase() == this.ROL_COMERCIAL);
            } else if (this.rolUsuario.Nombre == this.ROL_COMERCIAL) {
              this.arrListaAccesos = this.arrListaAccesos.filter(a => a.id_user == this.usuarioLogueado.id_user);
            } else {
              this.arrListaAccesos = [];
            }
          },
          (err: HttpErrorResponse) => {
            this.loading = false;
            if (err.error instanceof ErrorEvent) {
              console.error("Error Event");
            } else {
              this.msgStatus.getMessage(err.status);
            }
            Swal.fire({
              title: this.msgTitulos.Error,
              text: "LISTA ACCESOS NO OBTENIDA. " + this.msgStatus.message,
              type: "error",
              allowOutsideClick: false,
              heightAuto: false
            });
          }
        );

        this.subLista.push(this.subAcceso);

      },
      (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA ROLES NO OBTENIDA. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      }
    );

    this.subLista.push(this.subRol);
  }
  ListadoRepContabilidad(){
    this.loading = true;
    this.DTOFiltrosRepContabilidad.Tipo = 'operaciones_tiempo';
    this.subRepContabilidad = this.securityService.FiltroListadoRepContabilidad(this.DTOFiltrosRepContabilidad, this.datePipe.transform(this.fechaD, 'yyyy-MM-dd'), this.datePipe.transform(this.fechaH, 'yyyy-MM-dd')).subscribe(
      res => {
        this.dataReporte = res;
        this.planillas = this.dataReporte;
        this.dataSource = new MatTableDataSource(this.dataReporte);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.loading = false;
        this.securityService.dataBuffer = this.dataReporte;
        this.securityService.type_reporte = 'regular';
      },
      (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA REPORTE NO OBTENIDO. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      }
    );
  }
  seleccionarUsuario(event) {
    this.DTOFiltrosRepContabilidad.Usuario = event;
    /*this.loadingUser = true;
    Swal.fire({
      title: 'Espere',
      text: 'Obteniendo datos del usuario seleccionado',
      type: 'info',
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();
    let TipoUsuario = "COM";
    this.subUser = this.securityService.ObtenerUsuarios(TipoUsuario).subscribe(
      res => {

        this.usuarioFiltro = res;
        this.usuarioFiltro = this.usuarioFiltro.filter(u => u.Nombre == event);
        this.DTOFiltrosRepContabilidad.Usuario = this.usuarioFiltro[0].Usuario;
        this.loadingUser = false;
        if (this.loadingUser == false) {
          Swal.close();
        }

      },
      (err: HttpErrorResponse) => {

        this.loadingUser = false;
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "DATOS DEL USUARIO NO OBTENIDOS. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });

      }
    );

    this.subLista.push(this.subUser);*/
  }
  ExportTOExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.planillas);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Hoja1');
    let fecha = new Date();
    XLSX.writeFile(wb, 'Reporte_Movimientos_Inversionistas' + fecha + '.xlsx');
  }
}

